import { prop } from '@ipfabric/utils/fp/prop';
import { makeWrapWithButtonAsA } from 'components/Button/ButtonAsA';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import { selectAvailableEntities } from 'components/Graph/GraphSidePanel/selectors/selectAvailableEntities';
import { showSidePanel } from 'components/Graph/commands/showSidePanel';
import { submitTechnologies } from 'components/Graph/commands/topology/submitTechnologies';
import { updateStpInstanceIsolate } from 'components/Graph/commands/updateStpInstanceIsolate';
import { selectIsolateStpi } from 'components/Graph/model/selectors/graphMetadata/selectIsolateStpi';
import { useLocale } from 'containers/App/LocaleContext';
import { flow } from 'fp-ts/lib/function';
import type { FC } from 'react';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

const selectSomeDeviceTypeFiltered = createScopedSelector(() =>
  createSelector(
    flow(selectAvailableEntities, prop('deviceTypes')),
    prop('layoutSettings', 'preset', 'hiddenDeviceTypes'),
    (availableDeviceTypes, hiddenDeviceTypes) =>
      availableDeviceTypes.some((deviceType) =>
        hiddenDeviceTypes.includes(deviceType),
      ),
  ),
);

export const NetworkViewerNoDevices: FC = () => {
  const msgEmpty = useLocale().canvasGraph.emptyGraph.emptyNetworkViewer;

  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
    isolateStpi: selectIsolateStpi,
    someDeviceTypeFiltered: selectSomeDeviceTypeFiltered,
  });

  return (
    <>
      <p className='text-bold text-uppercase text-danger'>
        <i className='fa fa-exclamation-circle mr-2.5' />
        {msgEmpty.title}
      </p>
      {ctxProps.isolateStpi && (
        <p>
          {msgEmpty.isolateStpiActive({
            linkDeactivateStpiIsolate: makeWrapWithButtonAsA(() => {
              ctxProps.dispatch(updateStpInstanceIsolate, { isolate: false });
              ctxProps.dispatch(submitTechnologies);
            }),
          })}
        </p>
      )}
      {ctxProps.someDeviceTypeFiltered && (
        <p>
          {msgEmpty.filterActive({
            linkDeviceFilter: makeWrapWithButtonAsA(() => {
              ctxProps.dispatch(showSidePanel, {
                topologyLayoutSettingsTabId: 'devices',
              });
            }),
          })}
        </p>
      )}
    </>
  );
};
